<template>
  <div>
    <custom-dialog width="736px" :showClose="true" title="退费详情" v-if="visibleObj.refunDetailDialog"
      :visible="visibleObj.refunDetailDialog" @close="dialogVisible('refunDetailDialog')" @save="dialogVisible('refunDetailDialog')">
      <div class="content-warp" slot="content">
        <div class="order-warp">
          <div class="order-item">
            <div class="item-label">退费单号：</div>
            <div class="item-value">{{detail.id}}</div>
          </div>
          <div class="order-item">
            <div class="item-label">申请时间：</div>
            <div class="item-value">{{detail.createTime}}</div>
          </div>
          <div class="order-item">
            <div class="item-label">操作人：</div>
            <div class="item-value">{{detail.createBy}}</div>
          </div>
          <div class="order-item">
            <div class="item-label">订单号：</div>
            <div class="item-value">{{detail.orderNumber}}</div>
          </div>
          <div class="order-item">
            <div class="item-label">患者：</div>
            <div class="item-value">{{detail.patientName}}</div>
          </div>
          <div class="order-item">
            <div class="item-label">手机号号码：</div>
            <div class="item-value">{{detail.phone}}</div>
          </div>
          <div class="order-item">
            <div class="item-label">退费金额：</div>
            <div class="item-value">{{detail.amount}}</div>
          </div>
          <div class="order-item">
            <div class="item-label">退费原因：</div>
            <div class="item-value">{{detail.refundReason}}</div>
          </div>
        </div>
        <div class="comm-warp">
          <div class="comm-title">退费商品</div>
          <customTable class="customTable" :border="true" :showPages="false" :tableData="detail.itemList" :column="shopColumn"
            :header-cell-style="{ background: '#F0F1F3' }">
          </customTable>
        </div>
      </div>
    </custom-dialog>
  </div>
</template>
  
<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import customTable from '@/components/customTable/customTable'
import { payDTO } from '@/DTO/index'
export default {
  // 定义引入的组件
  components: { CustomDialog, customTable },
  props: {
    visibleObj: {
      type: Object,
      default: () => { return {} }
    },
    dialogObj: {
      type: Object,
      default: () => { return {} }
    },
  },
  data() {
    return {
      shopData: [],
      shopColumn: [
        { label: "商品名称", prop: "itemName" },
        { label: "退费数量", prop: "quantity" },
        { label: "金额", prop: "amount" },
      ],
      refundWayData: [],
      detail:{}

    }
  },
  //变量监听
  watch: {},
  // 页面初始化
  created() {
    this.getDetail()
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    /**
     * 查询退款详情
     */
    async getDetail() {
      let { code, data } = await payDTO.getRefundTask({ refundTaskId: this.dialogObj.refundTaskId })
      if (code == 200) {
        this.detail =data
      }
    },
    /**
    * 关闭
    */
    dialogVisible(name) {
      this.$emit("close", name);
    },
  },
}
</script>
<style lang="less" scoped>
.content-warp {
  .order-warp {
    background: #F9F9FA;
    padding: 12px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-row-gap: 12px;

    .order-item {
      display: flex;
      font-size: 14px;

      .item-label {
        flex-shrink: 0;
        color: #667182;
      }

      .item-value {
        color: #1F2329;
      }
    }
  }

  .comm-warp {
    margin-top: 16px;
    font-size: 14px;

    .comm-title {
      color: #1F2329;
      font-weight: 500;
      padding-left: 8px;
      border-left: 2px solid #1890FF;
      margin-bottom: 12px;
    }

  }

}
</style>